/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useToast } from '@chakra-ui/toast';
import api from '../../services/api';
import { IUser } from '../../dtos/user';
import DataTableComponent, { ColumnHeaders, getRowsPerPage } from '../../components/DataTable';
import UserModal from './UserModal';

interface GetData {
  filter?: string;
  sort?: string;
  page?: number;
  offset?: number;
  limit?: number;
}

const User = () => {
  const Toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [actionModal, setActionModal] = useState<'VIEW' | 'EDIT' | 'DEFAULT'>('DEFAULT');
  const [dataId, setDataId] = useState('');
  const [userList, setUserList] = useState<IUser[]>([]);
  const [filterValue, setFilterValue] = useState<string>();
  const [rowsPerPage] = useState(getRowsPerPage());
  const [currentPage, setCurrentPage] = useState(1);
  const [allRows, setAllRows] = useState(0);
  const [headers, setHeaders] = useState<ColumnHeaders[]>([]);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [sortable, setSsortable] = useState<string>();

  const getData = async ({ filter, sort, page, offset, limit = rowsPerPage }: GetData) => {
    try {
      setLoading(true);
      setCurrentPage(page || 1);
      setFilterValue(filter);
      setSsortable(sort);
      const query: string[] = [];
      if (filter) {
        query.push(`q=${filter}`);
      }
      if (sort) {
        query.push(`sort=${sort}`);
      }
      if (offset) {
        query.push(`skip=${offset}`);
      }
      if (limit) {
        query.push(`limit=${limit}`);
      }

      setUserList([]);
      setAllRows(0);
      const response: AxiosResponse = await api.get(`/user/list${query.length > 0 ? `?${query.join('&')}` : ''}`);
      if (response && response.data) {
        setUserList(response.data.rows);
        setAllRows(response.data.allRows);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const inactiveItem = async (item: IUser) => {
    try {
      const response: AxiosResponse = await api.get(`/user/${item._id}`);
      if (response && response.data) {
        response.data.active = false;
        await api.post('/user/save', response.data);
        getData({});
      }
    } catch (e) {
      Toast({
        status: 'error',
        title: 'Erro ao salvar dados!',
        description: e.message,
        position: 'top-right',
      });
    }
  };

  const closeForm = (reload = false) => {
    setActionModal('DEFAULT');
    setDataId('');
    setShowModal(false);
    if (reload) {
      getData({});
    }
  };

  useEffect(() => {
    setHeaders([
      { text: 'Login', value: 'login', align: 'center', sortable: true },
      { text: 'Name', value: 'name', alignHeader: 'center', sortable: true },
      { text: 'Email', value: 'email', alignHeader: 'center', sortable: true },
      { text: 'Ativo', value: 'active', type: 'boolean', align: 'center', sortable: true },
    ]);
    getData({});
  }, []);

  return (
    <>
      {showModal ? <UserModal dataId={dataId} action={actionModal} onCloseForm={closeForm} /> : null}
      <DataTableComponent
        isLoading={isLoading}
        headers={headers}
        itens={userList}
        filter={filterValue}
        paginationOptions={{
          allItems: allRows,
          itemsPerPage: rowsPerPage,
          page: currentPage,
        }}
        tableSync={(filter, sort, page, offset, limit) => {
          getData({ filter, sort, page, offset, limit });
        }}
        newItem={() => {
          setShowModal(true);
          setActionModal('EDIT');
        }}
        itemActionEdit={(item: IUser) => {
          // console.log(item.name);
          setDataId(item._id);
          setShowModal(true);
          setActionModal('EDIT');
        }}
        itemActionView={(item: IUser) => {
          setDataId(item._id);
          setActionModal('VIEW');
          setShowModal(true);
        }}
        // itemActionDelete={async (item: IUser) => {
        //   inactiveItem(item);
        // }}
        columnSortable={sortable}
      />
    </>
  );
};

export default User;
